import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || window.location.origin;

const api = axios.create({
    baseURL: API_URL,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 요청 인터셉터 설정
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 응답 인터셉터 설정
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            // 서버가 응답을 반환한 경우
            switch (error.response.status) {
                case 400:
                    console.error('잘못된 요청입니다:', error.response.data);
                    break;
                case 401:
                    console.error('인증되지 않은 요청입니다. 로그인이 필요합니다.');
                    // 로그인 페이지로 리다이렉트하거나 토큰 갱신 로직을 추가할 수 있습니다
                    break;
                case 403:
                    console.error('접근 권한이 없습니다.');
                    break;
                case 404:
                    console.error('요청한 리소스를 찾을 수 없습니다.');
                    break;
                case 500:
                    console.error('서버 내부 오류가 발생했습니다.');
                    break;
                default:
                    console.error('예상치 못한 오류가 발생했습니다:', error.response.status);
            }
        } else if (error.request) {
            // 요청은 보냈지만 응답을 받지 못한 경우
            console.error('서버로부터 응답이 없습니다:', error.request);
        } else {
            // 요청 설정 중에 오류가 발생한 경우
            console.error('요청 설정 중 오류가 발생했습니다:', error.message);
        }

        // 네트워크 오류 처리
        if (error.code === 'ECONNABORTED') {
            console.error('요청 시간이 초과되었습니다.');
        }

        return Promise.reject(error);
    }
);

export default api;